import React from 'react';
import { Button, Flex, Typography, theme } from 'antd';

import { NexusLogo } from './Nexus';

const { Text } = Typography;

export const NEXUS_BUTTON_LABEL = 'Ask Nexus';
export const NEXUS_BUTTON_DESCRIPTION = 'Your AI Integration Assistant';

// FIXME: no exact token — the width the design wraps the description at.
const LABEL_WIDTH = 132;

// FIXME: no exact token — the design's 6px sits between paddingXXS and paddingXS.
const LABEL_PADDING_BLOCK = 6;

// FIXME: no exact token — the square is rotated, so half its diagonal is what
// protrudes below the label as the tail.
const LABEL_TAIL_SIZE = 10;

export type NexusButtonProps = {
  readonly onClick: () => void;
};

export const NexusButton = ({ onClick }: NexusButtonProps) => {
  const { token } = theme.useToken();

  // How far the label reaches past the button's right edge: enough to clear the
  // guide pane on its left, not enough to overhang the right of the gutter.
  const labelOverhang = token.marginMD;

  return (
    <Flex style={{ position: 'relative' }}>
      <Flex
        vertical
        style={{
          // Out of flow and hung near the button's right edge rather than
          // centred on it: the label is wider than the button, and centred it
          // overhangs the right of the gutter. In flow its column would instead
          // push the button right of where the gutter puts it.
          position: 'absolute',
          bottom: `calc(100% + ${token.marginSM}px)`,
          right: -labelOverhang,
          width: LABEL_WIDTH,
          padding: `${LABEL_PADDING_BLOCK}px ${token.paddingXS}px`,
          borderRadius: token.borderRadius,
          // The design names components/tooltip/color-bg-spotlight, which is
          // translucent. This label is always on screen rather than summoned by
          // a hover, so it takes the opaque text colour instead.
          backgroundColor: token.colorTextBase,
        }}
      >
        <Text strong style={{ color: token.colorTextLightSolid }}>
          {NEXUS_BUTTON_LABEL}
        </Text>
        <Text style={{ color: token.colorTextLightSolid, fontSize: token.fontSizeSM }}>
          {NEXUS_BUTTON_DESCRIPTION}
        </Text>

        <div
          aria-hidden="true"
          style={{
            position: 'absolute',
            top: '100%',
            // Back in past the overhang to the button's centre, so the tail
            // points at the button wherever the label is hung.
            right: labelOverhang + token.controlHeightLG / 2,
            width: LABEL_TAIL_SIZE,
            height: LABEL_TAIL_SIZE,
            transform: 'translate(50%, -50%) rotate(45deg)',
            borderBottomRightRadius: token.borderRadiusXS,
            backgroundColor: token.colorTextBase,
          }}
        />
      </Flex>

      <Button
        type="primary"
        shape="circle"
        size="large"
        aria-label={NEXUS_BUTTON_LABEL}
        icon={<NexusLogo size={token.sizeLG} color={token.colorTextLightSolid} />}
        style={{ boxShadow: token.boxShadowSecondary }}
        onClick={onClick}
      />
    </Flex>
  );
};
